import { createSelector } from 'reselect'
import getAccessToken from './getAccessToken'
import decodeJWT from '../modules/decodeJWT'
import isAuthenticated from './isAuthenticated'

export default function makeHasPermission() {
  return createSelector(
    getAccessToken,
    isAuthenticated,
    (_, props) => props.permissions,
    (_, props) => props.permissionsWithRegex,
    (accessToken, authenticated, permissions, permissionsWithRegex) => {
      // Return true: allow access
      // Return false: block access

      // User is not authenticated
      if (!accessToken) {
        return false
      }

      // Make permissions and permissionsWithRegex array even when they are originally given as strings
      const permissionsAsArray = [].concat(permissions).filter(Boolean)
      const permissionsWithRegexAsArray = [].concat(permissionsWithRegex).filter(Boolean)

      // When an admin is signed in, these are the permissions it has access to
      const adminPermissions = decodeJWT(accessToken).admin ? decodeJWT(accessToken).admin.permissions : []
      // When a user is signed in, these are the permissions it has access to
      const userPermissions = decodeJWT(accessToken).permissions || []

      // First run through the simple permissionsArray with contains strings.
      // We check if the string includes (exists) in the adminPermissions array (of strings)
      // When permissionsAsArray is an empty array, when adminPermissions is an empty array or when
      // it finds all strings of permissionsAsArray in adminPermissions it will return true and thus
      // continue to the second expression.
      return permissionsAsArray.every(
        (permission) => adminPermissions.includes(permission) || userPermissions.includes(permission),
      )
        // So the first expression when successful, we now gonna do the same but with a regex check
        // and the values of permissionsWithRegexAsArray.
        && permissionsWithRegexAsArray.every((permissionWithRegex) => {
          const reg = new RegExp(permissionWithRegex)
          // It will return true as soon as it finds the first match and continues to the next item in the every.
          return !!adminPermissions.find((adminPermission) => reg.test(adminPermission))
            || !!userPermissions.find((adminPermission) => reg.test(adminPermission))
        })
    },
  )
}
